import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, fromEvent, merge } from 'rxjs';
import { HelpersService } from './shared/services/helpers.service';
import { NodeService } from './shared/services/node.services';
import { fadeAnimation } from './utility/animations';
import { Meta } from '@angular/platform-browser';
import { ViewportScroller, Location } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fadeAnimation]
})
export class AppComponent implements OnInit {
  public viewSplashScreen = true;
  private firstTime = true;
  public isOpenMenu: boolean = false;
  public resolveLang = false;
  public resolveAuth = false;
  public isPreviewMode = false;
  public eventUser = false;
  private subscriptionMouseMove: Subscription = new Subscription();

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private activedRoute: ActivatedRoute,
    public nodeService: NodeService,
    public helpersService: HelpersService,
    private meta: Meta,
    private scroller: ViewportScroller,
    private location: Location,
    ) {}

  ngOnInit(): void {
    // if(this.helpersService.isBrowser) {
    //   document.body.style.display = "block";
    // }
    this.enabledAcceptCookieListener();
    this.helpersService.setLocalStorage(this.helpersService.storageProjectCacheableKey, 'true');
    this.updateMetaTag('index, follow');
    this.setLanguage(); // set default language
    // this.onResolveAuth(); // listener on resolve authentication NO_TOKEN commentare
    this.checkQueryParams();
    this.helpersService.menuIsOpen.subscribe(value => this.isOpenMenu = value);
  }

  private enabledAcceptCookieListener() {
    if (this.helpersService.isBrowser) {
      this.subscriptionMouseMove = merge(
          fromEvent(document, 'mousemove'),
          fromEvent(document, 'touchmove'),
      ).subscribe((event: Event)=> {
        if (!this.eventUser && document.getElementById("Cookiebot") == null) {
          this.eventUser = true;
          const script = document.createElement('script');          
          script.setAttribute('id','Cookiebot');
          script.setAttribute('src','https://consent.cookiebot.com/uc.js');
          script.setAttribute('data-cbid','e30ba5f8-0142-487c-a2d9-ada2b61a7e37');
          script.setAttribute('type','text/javascript');
          script.setAttribute('async','');
          document.head.appendChild(script);
          this.subscriptionMouseMove.unsubscribe();
        }
      });
    }
  }


  private updateMetaTag(content: string): void {
    const robotsTag = this.meta.getTag('name="robots"');
    if (robotsTag) {
      this.meta.updateTag({ name: 'robots', content: content });
    } else {
      this.meta.addTag({ name: 'robots', content: content });
    }
  }

  private onNavigationEnd(): void {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd && this.helpersService.isBrowser) {
        
        /*let canonical_url: any = document.querySelector('meta[property="canonical_url"]');  
        if (canonical_url && canonical_url.content) {
          const urlTmp = new URL(canonical_url.content);
          const pathNameCanonicalUrl = urlTmp.pathname;
          if (pathNameCanonicalUrl != e.url) {
            window.location.href = pathNameCanonicalUrl;
          }
        }*/

        let countInterval = 0;
        let scrollToTop = window.setInterval(() => {
          countInterval++;
          if (countInterval > 2) {
            window.clearInterval(scrollToTop);
          }
          let pos = window.pageYOffset;
          if (pos > 0) {
              this.scroller.scrollToPosition([0, 0]);
          } else {
              window.clearInterval(scrollToTop);
          }
        }, 400);
      }
      if (e instanceof NavigationEnd && this.firstTime) {
        this.firstTime = false;
        if (e.url !== '/auth/healthcheck') {
          // this.checkUserStatus(); // NO_TOKEN commentare this.checkUserStatus
          this.onResolveAuth(); // NO_TOKEN decommentare 
        } else {
          this.viewSplashScreen = false;
        }
      }
      
    });
  }

  private onResolveAuth(): void { // NO_TOKEN commentare subscribe
    // this.helpersService.onEndCheckUserAuth.subscribe(res => {
      if (this.router.url === '/') {
        this.helpersService.goToHomeLang();
      }
      this.viewSplashScreen = false;
      this.resolveAuth = true;
    // });
  }

  private checkUserStatus(): void { // NO_TOKEN
    const accessTokenHasExpired = this.helpersService.hasExpired(this.helpersService.expiresInAccessToken);
    const refreshTokenHasExpired = this.helpersService.hasExpired(this.helpersService.expiresInRefreshToken);
    if (!accessTokenHasExpired) {
      if (this.helpersService.isBrowser) console.log('parte set interval con access token');
      this.helpersService.startIntervalAccessToken();
    } else if (accessTokenHasExpired && !refreshTokenHasExpired) {
      if (this.helpersService.isBrowser) console.log('parte chiamata access token da refresh token');
      this.helpersService.callRefreshAccessToken();
    } else {
      if (this.helpersService.isBrowser) console.log('parte login no auth');
      this.helpersService.callLoginNoAuth();
    }
  }

  private setLanguage() {
    this.translateService.addLangs(this.helpersService.langsCode);
    this.translateService.setDefaultLang(this.helpersService.defaultLangCode);
    let lang = this.helpersService.defaultLangCode;
    const savedlang = this.helpersService.lang;
    let browserLang: any = this.translateService.getBrowserLang();
    const foundBrowserLang = this.helpersService.languages.findIndex(l => l.codeApi === browserLang);
    if (foundBrowserLang < 0) {
      browserLang = null;
    }
    let langFromParam: any;
    if (this.helpersService.isBrowser) {
      langFromParam = window.frames.location.pathname.split('/')[1];
      const found = this.helpersService.languages.findIndex(l => l.codeApi === langFromParam);
      if (found < 0) {
        langFromParam = null;
      }
    }

    if (langFromParam) {
      lang = langFromParam;
    } else if (savedlang) {
      lang = savedlang;
    } else if (browserLang) {
      lang = browserLang;
    }

    let foundLangCode = this.helpersService.languages.findIndex(l => l.codeApi === lang);

    if (foundLangCode >= 0) {
      lang = this.helpersService.languages[foundLangCode].code;
    } else {
      lang = this.helpersService.languages.filter(l => l.default)[0].code;
    }

    this.helpersService.useLanguage(lang);
    this.resolveLang = true;
  }

  private checkQueryParams() {
    this.activedRoute.queryParams.subscribe(params => {
      if (params['content-preview-page']) {
        this.isPreviewMode = true;
      } else {
        this.isPreviewMode = false;
      }
      
      // http://localhost:4200/it/corsi?field_tipo_di_corso%5B0%5D=Laurea%20Triennale&refresh=true
      if (params['refresh'] && params['refresh']=="true" && this.helpersService.isBrowser) {
        let path = document.location.pathname ;
        let qp = document.location.search;
        qp = qp.replace("?refresh=true", "");
        qp = qp.replace("&refresh=true", "");
        path = path + qp;
        if (path == "/") {
          path = "";
        }
        this.location.replaceState(path );
      }
      this.onNavigationEnd(); // listener on navigation end
    });
  }
}
